import { useAppTranslation } from '../i18n/useAppTranslation';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, Typography, Button, CircularProgress } from '@mui/material';
import { CheckCircle, SportsScore } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { isNativeApp } from '../utils/platform';

const SubscriptionSuccess = () => {
  const { tr } = useAppTranslation();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isNativeApp()) { navigate('/coach/dashboard', { replace: true }); return; }
    const refresh = async () => {
      await refreshUser();
      setLoading(false);
    };
    refresh();
  }, []);

  if (isNativeApp()) return null;

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)'
    }}>
      <Container maxWidth="xs">
        <Paper elevation={24} sx={{ p: 5, borderRadius: 4, textAlign: 'center' }}>
          {loading ? (
            <CircularProgress size={60} />
          ) : (
            <>
              <CheckCircle sx={{ fontSize: 80, color: '#22C55E', mb: 2 }} />
              <SportsScore sx={{ fontSize: 36, color: 'primary.main', mb: 1 }} />
              <Typography variant="h4" fontWeight={900} gutterBottom>
                 {tr("Abonnement activé !")} </Typography>
              <Typography color="text.secondary" sx={{ mb: 4, lineHeight: 1.7 }}>
                 {tr("Bienvenue dans l'expérience Coach Pro G1Sport. Ton abonnement à")} <strong>{tr("24.90€/mois")}</strong>  {tr("est maintenant actif. Tu as accès à toutes les fonctionnalités.")} </Typography>
              <Button
                variant="contained" size="large" fullWidth
                onClick={() => navigate('/coach/dashboard')}
                sx={{ py: 1.8, borderRadius: 3, fontWeight: 800 }}
              >
                 {tr("Accéder à mon dashboard")} </Button>
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default SubscriptionSuccess;
